module.exports = __webpack_public_path__ + "static/media/main.590ba05a.png";